import React, { useEffect, useState } from 'react'
import PropTypes from 'prop-types'

const SwitchFilterSimGolf = ({
  switchFor,
  isChecked,
  setIsChecked,
  toggleGolfHubPublished,
  id,
  selectedDropdownOption,
  openPopup,
  popupTypes,
  openRegistrationData,
  golfHub,
  onChange,
  checkedSuffix,
  uncheckedSuffix,
}) => {
  const [suffix, setSuffix] = useState('');

  useEffect(() => {
    if (isChecked) {
      setSuffix(checkedSuffix)
    } else {
      setSuffix(uncheckedSuffix)
    }
  }, [switchFor, isChecked])

  useEffect(() => {
    if (openRegistrationData)
      setIsChecked(
        openRegistrationData.openRegistrationStatus === 'open' ||
        openRegistrationData.openRegistrationStatus === 'invitation_list'
      )
  }, [openRegistrationData])

  useEffect(() => {
    if (golfHub)
      setIsChecked(golfHub === window.I18n.t('customer_center_comp.components.sim_golf_labels.published'))
  }, [golfHub])

  const handleOnClick = (switchFor) => {
    if (switchFor === 'category') {
      setIsChecked(!isChecked)
      if (isChecked)
        onChange('viewType', 'list')
      else
        onChange('viewType', 'category')
        onChange('currentFilterName', 'season')
        onChange('category', 'all')
    } else if (switchFor === 'golfHub') {
      toggleGolfHubPublished(id, isChecked, `/leagues/${id}/publish_to_directory`)
    } else if (switchFor === 'openRegistration') {
      openPopup(popupTypes, { selectedDropdownOption })
    }
  }

  return (
    <span className='switch_button_category_container'>
      <label className='switch_button_category' id='switch_button'>
        <input type='checkbox' checked={ isChecked } onChange={ () => handleOnClick(switchFor) }/>
        <span className='switch_button_category_slider round'></span>
      </label>
      <span className='switch_label'>
        { suffix }
      </span>
    </span>
  );
}

SwitchFilterSimGolf.propTypes = {
  switchFor: PropTypes.string.isRequired,
  isChecked: PropTypes.bool,
  setIsChecked: PropTypes.func,
  onChange: PropTypes.func,
  toggleGolfHubPublished: PropTypes.func,
  id: PropTypes.string,
  selectedDropdownOption: PropTypes.object,
  openPopup: PropTypes.func,
  popupTypes: PropTypes.string,
  openRegistrationData: PropTypes.object,
  golfHub: PropTypes.string,
  checkedSuffix: PropTypes.string.isRequired,
  uncheckedSuffix: PropTypes.string,
}

export default SwitchFilterSimGolf